import { createContext } from 'react';
import { SideBarOptions } from '../../interfaces';

interface ContextProps {
  isOpenSideBar: boolean;
  optionSidebarOpen: SideBarOptions | null;

  //Métodos
  toggleSidebar: (optionSidebarOpen: SideBarOptions) => void;
  closeSidebar: () => void;
}

export const UiContext = createContext({} as ContextProps);